// 流入元：広告URLの utm_*・X広告のクリック（URL の twclid）・来る前のサイトを、開いたときに端末へ覚える。
// 新しくアカウントを作るときにサーバーへ送り、広告ごとの登録・課金を数える（apps/worker/src/sources.ts）。
// 広告から来たら上書きする（登録の直前に踏んだ広告を数える）。来る前のサイトだけのときは、まだ何も覚えていない場合だけ。
const KEY = 'hk.source';
const MAX_AGE = 30 * 86_400_000;

export type Source = { src?: string; med?: string; cmp?: string; cnt?: string; ad?: boolean; ref?: string; at: number };

/** 起動時に一度 */
export function captureSource() {
  try {
    const q = new URLSearchParams(location.search);
    const pick = (k: string) => q.get(k)?.slice(0, 64) || undefined;
    let ref: string | undefined;
    try {
      const h = document.referrer ? new URL(document.referrer).hostname : '';
      if (h && h !== location.hostname) ref = h;
    } catch {
      /* 読めない referrer は無視 */
    }
    const s: Source = { src: pick('utm_source'), med: pick('utm_medium'), cmp: pick('utm_campaign'), cnt: pick('utm_content'), ad: q.has('twclid') || undefined, ref, at: Date.now() };
    if (s.src || s.med || s.cmp || s.cnt || s.ad || (ref && !currentSource())) localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* 保存できない端末では送らない */
  }
}

/** 覚えている流入元（30日より古いものは使わない） */
export function currentSource(): Source | undefined {
  try {
    const s = JSON.parse(localStorage.getItem(KEY) ?? 'null') as Source | null;
    return s && Date.now() - s.at < MAX_AGE ? s : undefined;
  } catch {
    return undefined;
  }
}
